
import { buildPublisherNode } from '@/utils/seo'

export default {
  head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          hid: 'organization-structured-data',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            ...buildPublisherNode(this.$config.url),
            legalName: 'SARL ANDREAU',
            foundingDate: '2005-05-01',
            taxID: '482459948',
            vatID: 'FR79482459948',
            email: 'support@agmvision.com',
            telephone: '+33553551618',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '13 avenue Eugène Le Roy',
              postalCode: '24160',
              addressLocality: 'Excideuil',
              addressRegion: 'Nouvelle-Aquitaine',
              addressCountry: 'FR',
            },
            contactPoint: [
              {
                '@type': 'ContactPoint',
                telephone: '+33553551618',
                email: 'support@agmvision.com',
                contactType: 'customer service',
                areaServed: [
                  'FR',
                  'BE',
                  'CH',
                  'LU',
                  'ES',
                  'IT',
                  'DE',
                  'NL',
                  'PT',
                ],
                availableLanguage: [
                  'French',
                  'English',
                  'Spanish',
                  'German',
                  'Italian',
                  'Dutch',
                  'Portuguese',
                  'Japanese',
                ],
              },
            ],
            sameAs: [
              'https://www.facebook.com/agmvision/',
              'https://www.instagram.com/agm_vision/',
              'https://www.tiktok.com/@agmvision',
              'https://www.youtube.com/@agmvision',
              'https://www.avis-verifies.com/avis-clients/agmvision.com',
              'https://maps.app.goo.gl/WCKAyxjj8NgnMhZ89',
            ],
          }),
          type: 'application/ld+json',
        },
      ],
    }
  },
}
